import { UIHeading2, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import { RecentlyViewedItem } from '../RecentlyViewedItem';
import * as styles from './styles.css';
import { IRecentlyViewedOffer } from '../../types/recentlyViewedOffer';

export interface IRecentlyViewedProps {
  offers: IRecentlyViewedOffer[];
}

export const RecentlyViewed: React.FC<IRecentlyViewedProps> = ({ offers }) => {
  return (
    <div className={styles['wrapper']}>
      <div className={styles['container']}>
        <div>
          <div className={styles['title']}>
            <UIHeading2>Вы смотрели</UIHeading2>
          </div>
          <UIText1 color="text-secondary-default">Сохраняйте, чтобы не потерять</UIText1>
        </div>
        <div className={styles['scrollable']}>
          {offers.map((offer, index) => (
            <RecentlyViewedItem
              key={`recentlyViewedItem-${index}`}
              offer={offer}
              onClick={() => {}}
              position={index + 1}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
